import TablaDocumentos from "./TablaDocumentos"
import TablaWallet from "./TablaWallet"
const Documentos = () => {
    return (
        <div>
            <h4>Documentación Pasajeros</h4>
            <TablaDocumentos />
            <h4>Documentación</h4>
            <TablaWallet />
        </div>
    )
}
export default Documentos